import { COLORS } from '@laerdal/life-react-components';

const globalStyles = `

  html,
  body {
    font-family: 'Lato', sans-serif;
    font-size: 18px;
    color: ${COLORS.black};
    -webkit-font-smoothing: antialiased;
    @media print {
      font-size: 10pt;
    }
  }
  body {
    margin: 0;
    padding: 0;
  }
  main,
  aside,
  details {
    display: block;
  }

  summary {
    display: block;
  }

  #root {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  button,
  input,
  label {
    font-family: inherit;
  }

  ol li ol {
    list-style-type: lower-alpha;
  }

  ol li ol li ol {
    list-style-type: lower-roman;
  }

  h1:focus {
    outline: none;
  }
`;

export default globalStyles;
